import React, { createContext, useEffect, useReducer, useState } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";

const initialValue = {
    attribute: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                attribute_model: action.payload,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const ColorContext = createContext({
    attribute_model: initialValue,
    getColors: () => {},
    addColor: () => {},
    editColor: () => {},
    deleteColor: () => {},
    getColorById: () => {},
})

export const ColorsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError();

    const getColors = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/get_colors', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const getColorById = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/get_color/'+id, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const addColor = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/add_color', data, options);

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const editColor = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/edit_color', data, options);

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const deleteColor = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.delete('/api/products/delete_color/'+id, options);

            await getColors();

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Error", message: e.response?.data?.message??"Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    useEffect(() => {
        getColors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.status === 401){
        return <SessionOut />
    }

    if(state.attribute_model === undefined) {
        return <MatxLoading />
    }

    return (
        <ColorContext.Provider
            value={{
                attribute_model: state.attribute_model,
                getColors,
                getColorById,
                addColor,
                editColor,
                deleteColor
            }}
        >
            {children}
        </ColorContext.Provider>
    )
}

export default ColorContext
